import {
	SimpleSelectionDto,
	ProductPricingLine,
	Availability,
	ProductAddOnDto,
} from 'features/commerce/product-details/types';
import { BaseDto } from 'shared/types';
import { SimpleDisplayPrice, Price } from '../../../../../../Roc.SharedClientApp/types/commerce/display-price';
import { DropdownOption } from '../../../../../../Roc.SharedClientApp/types/fields';
import { ModelStatus } from '../../../../../../Roc.SharedClientApp/types/model-status';

/**
 * Represents a single addable to list product info
 */
export interface ItemToAddToList {
	itemId: string;
	quantity: number;
	productPricingLineId: string | null;
	addOns?: ProductAddOnDto[];
}

/**
 * Represents data needed for adding a single item to list
 */
export interface AddToListProps extends ItemToAddToList {
	shoppingListId: string;
}

/**
 * Represents data needed for adding multiple items to list
 */
export interface BulkAddToListProps {
	shoppingListId: string;
	items: ItemToAddToList[];
}

/**
 * List DTO interface for my account shopping lists
 */
export interface ShoppingListDto extends BaseDto {
	id: string;
	name: string;
	privacy: PrivacyType;
}

export interface ShoppingListResponse extends ShoppingListDto {
	productId: string | null;
	quantity: number | null;
}

/**
 * Shopping List Privacy Type
 */
export enum PrivacyType {
	Private = 'Private',
	Public = 'Public',
	Organization = 'Organization',
}

/**
 * Privacy Type Dropdown Options
 */
export const PrivacyTypeOptions = Object.keys(PrivacyType).map(
	(key) => ({ value: key, text: PrivacyType[key] } as DropdownOption),
);

export interface ShoppingListProductDto extends BaseDto {
	id: string;

	shoppingListId: string;

	productId: string;

	sku: string;

	name: string;

	url: string;

	groupUrl: string;

	unitPrice: SimpleDisplayPrice<Price>;

	selections?: SimpleSelectionDto[];

	pricingLine: ProductPricingLine;

	quantity: number;

	thumbnailUrl: string | null;

	brandName: string | null;

	altText?: string;

	status?: ModelStatus;

	availability?: Availability;

	/**
	 * The associated group product Id of a simple product, if applicable.
	 */
	productGroupId: string;

	/**
	 * The list of available product add ons for the shopping list item.
	 */
	addOns?: ProductAddOnDto[];
}
